import { Mail, MessagesSquare, MessageCircleHeart, MessageSquare } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { Channel } from '@/types';
import { Segmented } from '../ui/segmented';
import { channelKey, channelLabel } from './channels';

interface ChannelSelectorProps {
  channels: Channel[];
  selectedId?: string;
  onChange?: (id: string) => void;
  disabled?: boolean;
}

const CHANNEL_ICON: Record<string, LucideIcon> = {
  email: Mail,
  chat: MessagesSquare,
  social: MessageCircleHeart,
  sms: MessageSquare,
};

export const ChannelSelector = ({ channels, selectedId, onChange, disabled }: ChannelSelectorProps) => {
  if (!channels.length || !selectedId) return null;
  return (
    <Segmented
      value={selectedId}
      onChange={(id) => onChange?.(id)}
      disabled={disabled}
      options={channels.map((ch) => ({
        value: ch.id,
        label: channelLabel(ch),
        icon: CHANNEL_ICON[channelKey(ch)] ?? MessageSquare,
      }))}
    />
  );
};
